import React from 'react';

import BaseTable, { BaseTableCellContextType } from 'components/common/baseTable/BaseTable';

import { formatDate } from 'utils/chartUtils';

interface ActiveCampaign {
  campaignName: string;
  ctr: number; // Click-Through Rate
  budgetLeft: string;
  budgetTotal: string;
  impressions: number;
  clicks: number;
  ranking: number; // Ranking value between 0-100
}

interface BestPerformingCampaign {
  campaignName: string;
  ctr: number; // Click-Through Rate
  ranking: number; // Ranking value between 0-100
}
interface CampaignTablesProps {
  data: {
    activeCampaigns: ActiveCampaign[];
    bestPerformingCampaigns: BestPerformingCampaign[];
  };
}
const CampaignPerformanceTables = ({ data }: CampaignTablesProps): React.ReactElement => {
  // Column configurations for the CampaignPerformance tables
  const activeCampaignColumns = [
    { accessorKey: 'campaignName', header: 'Campaign Name' },
    { accessorKey: 'ctr', header: 'CTR (%)' },
    { accessorKey: 'budgetLeft', header: 'Budget Left' },
    { accessorKey: 'budgetTotal', header: 'Budget Total' },
    { accessorKey: 'impressions', header: '# of Impressions' },
    { accessorKey: 'clicks', header: '# of Clicks' },
    { accessorKey: 'mqa', header: '# of MQA Journey Transitions' },
  ];

  const bestPerformingCampaignColumns = [
    { accessorKey: 'campaignName', header: 'Campaign Name' },
    { accessorKey: 'ctr', header: 'CTR (%)' },
    {
      accessorKey: 'endDate',
      header: 'End Date',
      cell: ({ getValue }: BaseTableCellContextType) => {
        const value = getValue() as string;
        return <span>{formatDate(value)}</span>;
      },
    },
    { accessorKey: 'mqa', header: '# of MQA Journey Transitions' },
  ];

  return (
    <div className={'campaign-performance-tables'}>
      {/* Active Campaigns Table */}
      <BaseTable
        data={data.activeCampaigns}
        className={'campaign-performance-table'}
        columnDefinitions={activeCampaignColumns}
        title='Your Active Campaigns'
        initialPageSize={5}
        pageSizeOptions={[5, 10, 15]}
      />

      {/* Best Performing Campaigns Table */}
      <BaseTable
        data={data.bestPerformingCampaigns}
        className={'campaign-performance-table'}
        columnDefinitions={bestPerformingCampaignColumns}
        title="Your Company's Best Performing Campaigns"
        initialPageSize={5}
        pageSizeOptions={[5, 10, 15]}
      />
    </div>
  );
};
export default CampaignPerformanceTables;
